import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, List, ListItemButton, Paper, Stack, Typography } from '@mui/material';
import Add from '@mui/icons-material/Add';
import { useMisTramites } from '../../hooks/useTramites';
import { EstadoTramiteChip } from '../../components/Chips';
import { formatDate } from '../../utils/format';

interface Props {
  selectedId?: string;
  nuevoActivo?: boolean;
}

/** Lista de trámites del afiliado (columna izquierda de la bandeja). */
export default function TramiteLista({ selectedId, nuevoActivo }: Props) {
  const navigate = useNavigate();
  const { data, isLoading, error } = useMisTramites();
  const tramites = data ?? [];

  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h6">Mis trámites</Typography>
        <Button variant={nuevoActivo ? 'outlined' : 'contained'} size="small" startIcon={<Add />} onClick={() => navigate('/tramites/nuevo')}>
          Nuevo
        </Button>
      </Stack>
      {isLoading && (
        <Box sx={{ p: 3, textAlign: 'center' }}>
          <CircularProgress size={24} />
        </Box>
      )}
      {error && (
        <Alert severity="error" sx={{ m: 2 }}>
          No pudimos cargar tus trámites.
        </Alert>
      )}
      {!isLoading && !error && tramites.length === 0 && (
        <Typography color="text.secondary" sx={{ p: 3 }}>
          Todavía no iniciaste ningún trámite.
        </Typography>
      )}
      <List disablePadding aria-label="Lista de trámites">
        {tramites.map((t) => (
          <ListItemButton
            key={t.id}
            selected={t.id === selectedId}
            onClick={() => navigate(`/tramites/${t.id}`)}
            divider
            sx={{ alignItems: 'flex-start', gap: 1 }}
          >
            <Box sx={{ minWidth: 0, flexGrow: 1 }}>
              <Typography fontWeight={600} noWrap>
                {t.tipo}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {t.codigo} · {formatDate(t.created_at)}
              </Typography>
            </Box>
            <EstadoTramiteChip estado={t.estado} />
          </ListItemButton>
        ))}
      </List>
    </Paper>
  );
}
